import { useCallback, useMemo } from "react";

import { Button } from "@covertree/ui";
import { useCheckout } from "../CheckoutProvider";

export function BinderDocButton() {
  const {
    getBinderDocument,
    binderDocumentLoading,
    anythingLoading,
    selectedPaymentPlanKey,
    isMortgageBillFormValid,
  } = useCheckout();

  const printBinderHandler = useCallback(async () => {
    const document = await getBinderDocument();

    if (document) {
      window.open(document, "_blank");
    }
  }, [getBinderDocument]);

  const isDisabled = useMemo(
    () =>
      anythingLoading ||
      (selectedPaymentPlanKey === "mortgageBill" && !isMortgageBillFormValid),
    [anythingLoading, selectedPaymentPlanKey, isMortgageBillFormValid]
  );

  const tooltip = useMemo(
    () =>
      selectedPaymentPlanKey === "mortgageBill" && !isMortgageBillFormValid
        ? "Please complete all required fields for Mortgage Bill payment to proceed."
        : undefined,
    [selectedPaymentPlanKey, isMortgageBillFormValid]
  );

  return (
    <Button
      variant="outlined"
      onClick={printBinderHandler}
      sx={(theme) => ({
        marginTop: 2,
        height: {
          xs: theme.spacing(5),
          sm: theme.spacing(8),
        },
      })}
      loading={binderDocumentLoading}
      disabled={isDisabled}
      tooltip={tooltip}
      tooltipPlacement="bottom"
      fullWidth>
      Print Binder
    </Button>
  );
}
